define([], function() {
    var env_props = process.env.SITE_PROPERTIES;
    var root = null;
    try {
        root = window.location.origin;
    }
    catch(e) {
        //no origin;
    }
    if (root) {
        if (env_props.api_root == ":root") {
            env_props.api_root = root + "/";
        }
        if (env_props.io_root == ":root") {
            env_props.io_root = root + "/";
        }
    }
    var site_properties = {
        "logo": env_props.api_root + "api/v2/media/__logo?format=image",
        "title":"Ulysses 13",
        "api_root": env_props.api_root,
        "io_root": env_props.io_root,
        "login_buttons":[
            {
                //TODO: Sort out localisation here
                "button":"ok", "caption":"Registrami", "icon":"fa-check",
                "button_class":"btn btn-social bg-primary btn-block"
            } /*,{
                "button":"signup", "colour":"apple", "caption":"Not a user? Sign Up", "icon":"fa-lock", "button_class":"btn btn-social bg-apple btn-block"
            }*/
        ]
    };
    return site_properties;
});
